document.addEventListener('alpine:init', () => {
  Alpine.data('ColorOption', () => ({
    init() {
      this.InitSelf();
    },
    InitSelf() {
      this.$el.querySelectorAll('.swatch-element.color').forEach(($color) => {  
        let $input = $color.previousElementSibling;
        if ($color.classList.contains('on-sale')) {
          this.$el.querySelector('.sale-colors').appendChild($input);
          this.$el.querySelector('.sale-colors').appendChild($color);
          this.$el.querySelector('.sale-colors-wrap').classList.remove('hidden');
        }
        else {
          this.$el.querySelector('.regular-colors').appendChild($input);
          this.$el.querySelector('.regular-colors').appendChild($color);
        }
      });

      let $all_colors = this.$el.querySelectorAll('.swatch-element.color');
      let $colors_on_sale = [...$all_colors].filter(el => el.classList.contains('on-sale'));
      let $core_colors = [...$all_colors].filter(el => !el.classList.contains('on-sale'));

      if ($core_colors.length == 0) {
        this.$el.querySelector('.regular-colors-wrap').classList.add('hidden');
      }
      if ($colors_on_sale.length == 0) {
        this.$el.querySelector('.sale-colors-wrap').classList.add('hidden');
      }
    }
  }));
});